import { useEffect, useState } from "react";
import Carousel from 'react-bootstrap/Carousel';
import { discoverGeorgesConfig } from "../../../../config/discoverGeorgesConfig";
import styles from "./DiscoverGeorgesModal.module.scss";

const DiscoverGeorgesModal = ({setSelectedMode, setSelectedMenu, showDiscoverModal}: {setSelectedMode: (mode: string) => void, setSelectedMenu: (menu: number) => void, showDiscoverModal: boolean}) => {

    const [currentPage, setCurrentPage] = useState(-1); //-1: Main Menu, 0: How to start ?, 1: Understanding Georges's modes, 2: Getting internet information, 3: Uploading your own documents, 4: Generating a document synthesis, 5: George on mobile
    const [index, setIndex] = useState(0);
    
    const COPILOT_SSO_URL = "https://m365.cloud.microsoft/chat/?auth=2&home=1&fromcode=cmm6e0ny53n";
    const PERPLEXITY_SSO_URL = "https://launcher.myapps.microsoft.com/api/signin/52a3b076-ec4b-40ce-92d7-018449b768d3?tenantId=7fc6be4a-81b6-457d-9ad7-c8d5c64d052c";
    const openInNewTab = (url: string) => window.open(url, "_blank", "noopener,noreferrer");
    
    useEffect(() => {
        setIndex(0);
    }, [currentPage]);

    const handleSelect = (selectedIndex: number) => {
        setIndex(selectedIndex);
    };

    const mainMenu = () => (
        <>
        {discoverGeorgesConfig.map((category, index) => (
            <div className={styles.discoverModalContent} onClick={(e) => {e.stopPropagation(); setCurrentPage(index);}}>
                <i className={category.icon} style={{fontSize: 20}}></i>
                {category.title}
            </div>
        ))}
        </>
    )

    const actions = {
        "Open Filters and select documents Menu": () => setSelectedMenu(1),
        "See some prompts examples here": () => setSelectedMenu(3),
        "Modes training": () => setCurrentPage(1),
        "Set Mode Search Infravia": () => setSelectedMode("SEARCH"),
        "Set Mode Generalist Chat": () => openInNewTab(COPILOT_SSO_URL),
        "Set Mode Explore": () => openInNewTab(PERPLEXITY_SSO_URL),
        "Set Mode Chat with your docs": () => setSelectedMode("MYGEORGES"),
        "Chat with your Docs presentation": () => setCurrentPage(2),
        "Follow your uploads": () => setSelectedMenu(5),
        "Follow the summarizing": () => setSelectedMenu(5),
        "Open my documents": () => setSelectedMenu(1),
        "View a summary and deep-dive training": () => setCurrentPage(4),
        "Select 'Chat with my docs' mode": () => null,
        "Chat with your doc": () => null
    }

    const Trainings = (currentPage: number) => (
        <div style={{position: "relative", width: "100%", padding: 30, overflowY: "hidden", height: "100%", overflowX: "hidden"}}>
            <div className={styles.backButton} onClick={(e) => {e.stopPropagation(); setCurrentPage(-1)}}>Back to menu</div>
            <Carousel style={{height: "100%", width: "100%"}} interval={null} activeIndex={index} onSelect={handleSelect}>
                {discoverGeorgesConfig[currentPage].steps.map((step, index) => (
                    <Carousel.Item key={index} style={{height: "100%", width: "100%", paddingLeft: 50, paddingRight: 50, paddingTop: 30, paddingBottom: 30}}>
                        <h5>{step.title}</h5>
                        <i className={step.icon} style={{fontSize: 20}}></i>
                        <p style={{fontSize: 16, fontWeight: "normal"}}>{step.text}</p>
                        {step.action && <div className={styles.actionButton} onClick={() => actions[step.action as keyof typeof actions]()}>
                            {step.action}
                        </div>}
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    )


    return (showDiscoverModal ? 
        (<div className={styles.discoverModal} style={{width: window.innerWidth/2-200}} onClick={(e) => {e.stopPropagation();}}>
            {currentPage === -1 ? mainMenu() : <></>}
            {currentPage !== -1 ? Trainings(currentPage) : <></>}
        </div>) 
        : null)
};

export default DiscoverGeorgesModal;